export const SETTINGS_PATH = '/settings' as const;
export const ROOT = {
  PATH: SETTINGS_PATH,
  toPath: () => SETTINGS_PATH,
};
